import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { assembleContactEmail, ObfuscatedEmail } from '../components/ObfuscatedEmail';
import { submitInquiry } from '../utils/submitInquiry';
import '../styles/Alerts.css';

const Alerts = () => {
  const [email, setEmail] = useState('');
  const [topics, setTopics] = useState({
    eju: true,
    mext: true,
    kyotsu: false,
  });
  const [website, setWebsite] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const topicList = [
    topics.eju && 'EJU 회차·시라버스',
    topics.mext && '국비(MEXT) 공고',
    topics.kyotsu && '공통테스트 시즌',
  ].filter(Boolean);

  const message = [
    '[미라이쥬쿠 시즌 알림 신청]',
    `이메일: ${email || '—'}`,
    `관심: ${topicList.join(', ') || '없음'}`,
    '',
    '범위: 입시 시즌·공식 일정 알림만 (광고·강의 판매 메일 없음)',
  ].join('\n');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (website) return;
    if (!topicList.length) {
      setError('관심 주제를 하나 이상 선택해 주세요.');
      return;
    }

    setSubmitting(true);
    setSuccess(null);
    setError(null);

    try {
      await submitInquiry({
        name: '시즌알림',
        email,
        subject: `[미라이쥬쿠 시즌알림] ${email}`,
        message,
        honey: website,
        extra: { kind: 'season_alert' },
      });
      setSuccess(
        '신청이 전달되었습니다. 시즌 안내는 등록하신 메일로만 보냅니다. 광고·강의 판매 메일은 보내지 않습니다.'
      );
      setEmail('');
    } catch (err) {
      console.error(err);
      setError(
        `자동 전송에 실패했습니다. 아래 내용을 복사해 ${assembleContactEmail()} 으로 보내 주세요.`
      );
      try {
        await navigator.clipboard.writeText(message);
      } catch (_) {
        /* ignore */
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="apple-page apple-alerts">
      <header className="apple-page-hero">
        <p className="apple-eyebrow">Alerts</p>
        <h1 className="apple-display">시즌 알림</h1>
        <p className="apple-lede">
          EJU·국비·공통테스트처럼 시즌이 오는 일정만 메일로 알려 드립니다. 학원 광고·강의 판매
          메일은 보내지 않습니다.
        </p>
      </header>

      <ul className="apple-alerts-points">
        <li>보내는 내용: 공식 일정·시라버스·공고 확인 리마인더 (연 수 회 이내 목표)</li>
        <li>보내지 않는 내용: 할인 광고, 강의 세일, 제3자 마케팅</li>
        <li>해지: 수신 메일에 회신하거나 <ObfuscatedEmail /> 로 요청</li>
      </ul>

      {success && <div className="apple-alerts-banner is-ok">{success}</div>}
      {error && <div className="apple-alerts-banner is-err">{error}</div>}

      <form className="apple-alerts-form" onSubmit={handleSubmit}>
        <div className="apple-alerts-honey" aria-hidden="true">
          <label>
            website
            <input
              tabIndex={-1}
              autoComplete="off"
              name="website"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
          </label>
        </div>

        <label>
          이메일 *
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
          />
        </label>

        <fieldset>
          <legend>관심 주제</legend>
          <label className="apple-alerts-check">
            <input
              type="checkbox"
              checked={topics.eju}
              onChange={(e) => setTopics((t) => ({ ...t, eju: e.target.checked }))}
            />
            EJU 회차·시라버스
          </label>
          <label className="apple-alerts-check">
            <input
              type="checkbox"
              checked={topics.mext}
              onChange={(e) => setTopics((t) => ({ ...t, mext: e.target.checked }))}
            />
            국비(MEXT) 공고
          </label>
          <label className="apple-alerts-check">
            <input
              type="checkbox"
              checked={topics.kyotsu}
              onChange={(e) => setTopics((t) => ({ ...t, kyotsu: e.target.checked }))}
            />
            공통테스트 시즌
          </label>
        </fieldset>

        <button type="submit" className="apple-btn apple-btn-primary" disabled={submitting}>
          {submitting ? '전송 중…' : '알림 신청'}
        </button>
      </form>

      <p className="apple-alerts-note">
        신청 시 이메일이 FormSubmit을 통해 운영 메일로 전달됩니다. 자세한 내용은{' '}
        <Link to="/privacy">개인정보처리방침</Link>을 보세요.
      </p>

      <div className="apple-page-foot">
        <Link to="/calendar" className="apple-btn apple-btn-primary">
          시즌 일정
        </Link>
        <Link to="/pass" className="apple-link">
          시즌패스 (연 39,000원)
        </Link>
        <Link to="/resources" className="apple-link">
          공식 자료
        </Link>
      </div>
    </div>
  );
};

export default Alerts;
